import { App } from '../../screens/HomeScreen/HomeScreen'
import { SOUNDS } from '../../constants/sounds'
import { useSound } from '../../hooks/useSound'
import styles from './Dock.module.css'

type PinnedApp = { name: string; icon: string }

type DockProps = {
  pinned: PinnedApp[]
  running: App[]
  activeAppName?: string | null
  minimizedApps: string[]
  onClickApp: (name: string) => void
}

const SPECIAL_APPS = new Set(['Trash'])

export default function Dock({
  pinned,
  running,
  activeAppName,
  minimizedApps,
  onClickApp
}: DockProps) {
  const pinnedNames = new Set(pinned.map(p => p.name))
  const runningNotPinned = running.filter(
    a => !pinnedNames.has(a.name) && !SPECIAL_APPS.has(a.name)
  )

  const playClick = useSound(SOUNDS.CLICK, { volume: 0.5 })

  const handleClickApp = (name: string) => {
    playClick()
    onClickApp(name)
  }

  return (
    <div className={styles.dock}>
      {pinned.map((app, index) => {
        const isRunning = running.some(r => r.name === app.name)
        const isMin = minimizedApps.includes(app.name)
        const isActive = activeAppName === app.name
        return (
          <div
            key={`p-${index}`}
            className={`${styles.dockItem} ${isActive ? styles.active : ''} ${isMin ? styles.minimized : ''}`}
            onClick={() => handleClickApp(app.name)}
            title={app.name}
          >
            <img src={app.icon} alt={app.name} className={styles.dockIcon} />
            {isRunning && <span className={styles.dot} />}
          </div>
        )
      })}

      {runningNotPinned.map((app, index) => {
        const isMin = minimizedApps.includes(app.name)
        const isActive = activeAppName === app.name
        return (
          <div
            key={`r-${index}`}
            className={`${styles.dockItem} ${isActive ? styles.active : ''} ${isMin ? styles.minimized : ''}`}
            onClick={() => handleClickApp(app.name)}
            title={app.name}
          >
            <img src={app.icon} alt={app.name} className={styles.dockIcon} />
            <span className={styles.dot} />
          </div>
        )
      })}

      <div className={styles.dockSeparator} />

      <div 
        className={`${styles.dockItem} ${activeAppName === 'Trash' ? styles.active : ''}`}
        title="Trash"
        onClick={() => handleClickApp('Trash')}
      >
        <img src="/images/apps/trash.svg" alt="Trash" className={styles.dockIcon} />
        {running.some(r => r.name === 'Trash') && <span className={styles.dot} />}
      </div>
    </div>
  )
}